/**
 * Pusher stub dla LessSEO MVP. Lesscms używa Pusher do live events; LessSEO
 * jeszcze nie ma takich potrzeb — utrzymujemy stub żeby istniejący auth.js
 * nie crashował na imporcie ani przy `initializePusher(user.uuid)`.
 *
 * Gdy będziemy mieli realne live events (status audytu, AI generation done),
 * zaimplementujemy pełną wersję ze sprawdzeniem `VUE_APP_PUSHER_KEY`.
 */

export const FILE_MANAGER_EVENT = "fileManagerUpdate";

export function handleFileManagerEvent(data) {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent(FILE_MANAGER_EVENT, { detail: data }));
    }
}

export function initializePusher() {
    return null;
}

export function disconnectPusher() {
    // no-op
}

export const channel = null;
export const pusher = null;
